module.exports = __webpack_public_path__ + "img/full6-min.97e6d4ea.png";